module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0034.jpg?v=12ebeb0e";